import { CaseData } from '@/types/case';

export function isJudicialCase(caseData: CaseData | null | undefined): boolean {
    return (caseData?.team?.teamType ?? '').toLowerCase() === 'judicial';
}

export function isJudicialTeamType(teamType: string | null | undefined): boolean {
    return (teamType ?? '').toLowerCase() === 'judicial';
}
